import { cn } from "@/lib/utils"
import { GRADING_TABLE_DISCARDED_FG_STYLE } from "@/lib/grading/table-styles"

/** Em dash empty glyph for discarded score / grade / grade status (matches DS `EMPTY_DASH`). */
const DISCARDED_FIELD_DASH = "—"

/** Discarded submission empty field glyph (score, grade, grade status). */
export function DiscardedFieldDash({
  className,
  decorative = false,
}: {
  className?: string
  /** When true, parent supplies the accessible name (e.g. grade cell tooltip). */
  decorative?: boolean
}) {
  return (
    <span
      className={cn("text-sm", className)}
      style={GRADING_TABLE_DISCARDED_FG_STYLE}
      {...(decorative
        ? { "aria-hidden": true }
        : { "aria-label": "Not applicable" })}
    >
      {DISCARDED_FIELD_DASH}
    </span>
  )
}
